import { render, staticRenderFns } from "./app-user.vue?vue&type=template&id=de71da50&scoped=true&"
import script from "./app-user.vue?vue&type=script&lang=js&"
export * from "./app-user.vue?vue&type=script&lang=js&"
import style0 from "./app-user.vue?vue&type=style&index=0&id=de71da50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de71da50",
  null
  
)

export default component.exports